// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__xVOkU","col":"Table_col__PEliT","fulfillmentStatus":"Table_fulfillmentStatus__1Y0C3","emailCol":"Table_emailCol__NHvKO"};